import { NgModule } from '@angular/core';
import { FileUploadDirective } from './file-upload.directive';
import { FilePreviewComponent } from './file-preview.component';
import { CommonModule } from '@angular/common';

const exports = [
  FileUploadDirective,
  FilePreviewComponent
];

@NgModule({
    imports: [
        CommonModule,
        ...exports
    ],
    exports
})
export class FileUploadModule { }
